export const API = {
  categories: {
    path: '/categories',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  category: {
    path: '/categories/{{id}}',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  create: {
    path: '/categories',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
        area: body?.area?.id,
        location: body?.location?.toUpperCase(),
        marina: body?.marina?.toUpperCase(),
        code: body?.code,
      },
    }),
  },
  update: {
    path: '/categories/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
      },
    }),
  },
  delete: {
    path: '/categories/{{id}}',
    method: 'DELETE',
    get: null,
    auth: true,
    fallback: null,
  },
  select: {
    path: '/categories?pagination[page]=1&pagination[pageSize]=1000',
    method: 'GET',
    get: 'data',
    auth: true,
    fallback: [],
    transform: (data) =>
      data.map((item) => ({
        name: item.attributes.name,
        id: item.id,
      })),
  },
};
